import { usePageWrapperData } from '@/app/common/pageWrapperProvider';
import customCss from '@/app/components/hotel-detail/css/customCss';
import { DeprecatedLink as Link, Text } from '@lmn/design-system';
import type { Brand } from '@/domainLogic/index.ts';
import type { HTMLAttributes } from 'react';
import styled, { css } from 'styled-components';
import { formatPrice } from '@/app/components/search/utils/formatting.ts';
import { useTranslation } from '../translations/Translation';

function deferredPaymentImageMap(brand: string): string {
  const brandImages: { [key: string]: string | null } = {
    wegde: 'monthlyPayments_Orange.svg',
  };
  return brandImages[brand] || 'monthlyPayments_LM.svg';
}

const Banner = styled.div`
  display: flex;
  align-items: center;

  background-color: white;
  padding: 16px;
  gap: 16px;

  @media ${customCss.breakpoints.sm} {
    border-radius: 8px;
  }
`;

type BannerDeferredPaymentsProps = {
  smallAmountDeposit: boolean;
} & HTMLAttributes<HTMLElement>;

const BannerDeferredPayments = (props: BannerDeferredPaymentsProps) => {
  const { t } = useTranslation();
  const { localization, staticData } = usePageWrapperData();
  const { smallAmountDeposit, ...rest } = props;
  const { imageBasePath } = localization;

  return (
    <Banner {...rest}>
      <div
        css={`
          height: 60px;
          min-width: 60px;
          width: 60px;

          img {
            width: 100%;
            height: 100%;
          }
        `}
      >
        <img src={`${imageBasePath}${deferredPaymentImageMap(staticData.domainValues?.brand as Brand)}`} alt="icon" />
      </div>
      <div>
        <Text variant="Title4">
          {smallAmountDeposit
            ? t('vacation.select.details.deferredpayments.banner.min_deposit.title', {
                amount: formatPrice({ price: 1, localization }),
              })
            : t('vacation.select.details.deferredpayments.banner.title')}
        </Text>
        <Text variant="BodySmall">
          {smallAmountDeposit
            ? t('vacation.select.details.deferredpayments.banner.min_deposit.subtitle', {
                amount: formatPrice({ price: 1, localization }),
              })
            : t('vacation.select.details.deferredpayments.banner.subtitle')}
        </Text>
        {!smallAmountDeposit && (
          <div
            css={`
              margin-top: 4px;
            `}
          >
            {localization.deferredPaymentLink ? (
              <Link
                href={localization.deferredPaymentLink}
                target="_blank"
                variant="accent"
                rel="noopener noreferrer"
                css={css`
                  ${({ theme }) => theme.kallisto.mixins.font('BodySmall')}
                `}
              >
                {t('vacation.select.details.deferredpayments.banner.link')}
              </Link>
            ) : null}
          </div>
        )}
      </div>
    </Banner>
  );
};

export default BannerDeferredPayments;
